/*
Copyright 2023 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { anything, arrayOf, boolean, mapOfValues, objectOf, string } from "../../utils/validation/index.js";
export default ({
  options
}) => {
  const validator = objectOf({
    renderDecisions: boolean(),
    responseHeaders: mapOfValues(string().required()),
    responseBody: objectOf({
      handle: arrayOf(objectOf({
        type: string().required(),
        payload: anything().required()
      })).required()
    }).required(),
    personalization: objectOf({
      sendDisplayEvent: boolean().default(true),
      decisionContext: objectOf({})
    }).default({
      sendDisplayEvent: true
    })
  }).noUnknownFields();
  return validator(options);
};